import axios from 'axios';

const API_URL = '/api/v1';

export const getWishes = async (token, eventId = null, page = 1, userId = null, filters = {}) => {
  const params = {
    page,
    ...(eventId          ? { event_id: eventId }         : {}),
    ...(userId           ? { user_id: userId }            : {}),
    ...(filters.category ? { category: filters.category } : {}),
    ...(filters.timing   ? { timing: filters.timing }     : {}),
    ...(filters.sort     ? { sort: filters.sort }         : {})
  };
  const response = await axios.get(`${API_URL}/wishes`, {
    headers: { Authorization: `Bearer ${token}` },
    params
  });
  return response.data;
};

export const deleteWish = async (id, token) => {
  await axios.delete(`${API_URL}/wishes/${id}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
};

export const createWish = async (eventId, token) => {
    const response = await axios.post(`${API_URL}/wishes`,
      { wish: { event_id: eventId } },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  };
